.toolNameCell {
    display: flex;
    align-items: center;
    gap: 10px;
}

.connectorIcon {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    border-radius: 4px;
}

.toolNameInfo {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-3x-small);
}

.toolTitle {
    font: var(--exo-text-body-medium);
}

.toolId {
    font-size: 11px;
    color: var(--exo-color-font-secondary);
}

.toolDescription {
    color: var(--exo-color-font-secondary);
    max-width: 420px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.selectedRow:nth-child(n) {
    background-color: var(--exo-color-background-selected-weak);
}

.toolbar {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-x-small);
    padding: var(--exo-spacing-x-small) var(--exo-spacing-small);
    margin-top: var(--exo-spacing-x-small);
    background-color: var(--exo-color-background-secondary);
    border-radius: var(--exo-radius-standard);
}

.toolbarActions {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-2x-small);
}
